import type { ChecklistDeadline, EventState, PackageState, ServiceKind } from '@/api/types';
import type { PillTone } from '@/components/kit/Pill';

/**
 * Подписи и тона состояний — в одном месте, потому что они встречаются
 * на пяти экранах и обязаны читаться одинаково.
 *
 * Тон здесь про жизненный цикл, а не про оценку: черновик не «плохо»,
 * он просто ещё не виден продажам.
 */

export const EVENT_STATE: Record<EventState, { tone: PillTone; label: string }> = {
  draft: { tone: 'mut', label: 'Черновик' },
  live: { tone: 'ok', label: 'Опубликовано' },
  done: { tone: 'info', label: 'Завершено' },
};

export const PACKAGE_STATE: Record<PackageState, { tone: PillTone; label: string }> = {
  draft: { tone: 'mut', label: 'Черновик' },
  live: { tone: 'ok', label: 'В продаже' },
  stopped: { tone: 'info', label: 'Снят с продажи' },
};

export const SERVICE_KIND: Record<ServiceKind, { mark: string; label: string; plural: string }> = {
  masterclass: { mark: 'МК', label: 'Мастер-класс', plural: 'Мастер-классы' },
  ticket: { mark: 'БЗ', label: 'Билет зрителя', plural: 'Билеты зрителей' },
  showcase: { mark: 'ШК', label: 'Шоукейс', plural: 'Шоукейсы' },
};

export const PACKAGE_KIND: Record<'main' | 'extra', string> = {
  main: 'основной',
  extra: 'дополнительный',
};

export const SEATING: Record<'free' | 'numbered', string> = {
  free: 'без мест',
  numbered: 'с местами',
};

export const SELECTION: Record<'video' | 'none', string> = {
  video: 'видеоотбор',
  none: 'без отбора',
};

/** Какой пункт чек-листа номера закрывает дедлайн (БЛ M3 5.21): «не закрывает» и три пункта */
export const CHECKLIST_DEADLINE_ITEMS: { value: ChecklistDeadline | 'none'; label: string }[] = [
  { value: 'none', label: 'не закрывает' },
  { value: 'composition', label: 'Состав' },
  { value: 'materials', label: 'Музыка, видео, костюмы' },
  { value: 'admission', label: 'Допуск' },
];
